var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassrose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 153,
    viewBox: "0 0 155 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.298 11.7638C115.034 11.7639 144.005 40.76 144.005 76.5294C144.005 112.299 115.034 141.295 79.298 141.295C43.5618 141.295 14.5909 112.299 14.5909 76.5294C14.591 40.7599 43.5618 11.7638 79.298 11.7638Z",
    stroke: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1035 29.5982C105.399 29.5982 126.707 50.6962 126.707 76.7105C126.707 102.725 105.399 123.822 79.1035 123.822C52.8081 123.822 31.5002 102.725 31.5 76.7105C31.5 50.6961 52.808 29.5982 79.1035 29.5982Z",
    stroke: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.168 43.6779C97.193 43.6779 111.806 58.3035 111.806 76.3459C111.806 94.3882 97.1929 109.014 79.168 109.014C61.1431 109.014 46.5303 94.3881 46.5303 76.3459C46.5303 58.3036 61.1431 43.678 79.168 43.6779Z",
    stroke: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5088 60.5736C88.3828 60.5738 95.5771 67.7744 95.5771 76.6576C95.5771 85.5408 88.3828 92.7414 79.5088 92.7416C70.6346 92.7416 63.4395 85.5409 63.4395 76.6576C63.4395 67.7743 70.6346 60.5736 79.5088 60.5736Z",
    stroke: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8182 30.9755L124.68 121.92",
    stroke: "#9E9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8182 122.025L124.68 31.0805",
    stroke: "#9E9E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9091 139.859V11.9127",
    stroke: "#9E9E9E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0303 76.0307H144.151",
    stroke: "#9E9E9E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4019 2.016H81.2489V7H80.5769L77.8889 3.507V7H77.0489V2.016H77.7209L80.4019 5.502V2.016Z",
    fill: "#9E9E9E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7699 73.3534H9.6379L7.8739 78.3374H7.1389L5.8859 74.7534L4.6189 78.3374H3.8839L2.1269 73.3534H3.0439L4.2899 77.0704L5.5849 73.3534H6.2289L7.4959 77.0984L8.7699 73.3534Z",
    fill: "#9E9E9E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.578 78.3374V73.3534H150.91V74.0674H148.46V75.4464H150.763V76.1604H148.46V77.6234H150.91V78.3374H147.578Z",
    fill: "#9E9E9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1256 149.364C78.7429 149.364 78.3836 149.312 78.0476 149.21C77.7162 149.107 77.4339 148.96 77.2006 148.769L77.5086 148.111C77.7512 148.293 78.0032 148.428 78.2646 148.517C78.5306 148.601 78.8199 148.643 79.1326 148.643C79.4779 148.643 79.7439 148.582 79.9306 148.461C80.1219 148.339 80.2176 148.169 80.2176 147.95C80.2176 147.763 80.1289 147.621 79.9516 147.523C79.7789 147.42 79.4919 147.324 79.0906 147.236C78.4652 147.1 78.0102 146.925 77.7256 146.711C77.4409 146.496 77.2986 146.183 77.2986 145.773C77.2986 145.479 77.3779 145.217 77.5366 144.989C77.6952 144.76 77.9192 144.58 78.2086 144.45C78.5026 144.319 78.8409 144.254 79.2236 144.254C79.5736 144.254 79.9049 144.307 80.2176 144.415C80.5349 144.517 80.7939 144.662 80.9946 144.849L80.6936 145.507C80.2502 145.152 79.7602 144.975 79.2236 144.975C78.9016 144.975 78.6472 145.042 78.4606 145.178C78.2739 145.308 78.1806 145.488 78.1806 145.717C78.1806 145.913 78.2622 146.062 78.4256 146.165C78.5936 146.267 78.8782 146.363 79.2796 146.452C79.6949 146.55 80.0332 146.657 80.2946 146.774C80.5559 146.886 80.7566 147.033 80.8966 147.215C81.0366 147.392 81.1066 147.616 81.1066 147.887C81.1066 148.185 81.0272 148.447 80.8686 148.671C80.7099 148.89 80.4812 149.06 80.1826 149.182C79.8839 149.303 79.5316 149.364 79.1256 149.364Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassrose1);
export default __webpack_public_path__ + "static/media/compassrose-1.637fb81ca18c7ea6c9274feecf52dd1b.svg";
export { ForwardRef as ReactComponent };